/**
 * @generated SignedSource<<b57886219103f09ff8ed60a3f6a38790>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineEditChecklistTaskItemGenerateUploadLinkMutation$variables = Record<PropertyKey, never>;
export type RoutineEditChecklistTaskItemGenerateUploadLinkMutation$data = {
  readonly uploadImageLink: {
    readonly image: {
      readonly id: string;
    };
    readonly url: string;
  } | null;
};
export type RoutineEditChecklistTaskItemGenerateUploadLinkMutation = {
  response: RoutineEditChecklistTaskItemGenerateUploadLinkMutation$data;
  variables: RoutineEditChecklistTaskItemGenerateUploadLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UploadImageLinkResponse",
    "kind": "LinkedField",
    "name": "uploadImageLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineEditChecklistTaskItemGenerateUploadLinkMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RoutineEditChecklistTaskItemGenerateUploadLinkMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "708f07198cb2d79f50c20311c5097f7c",
    "id": null,
    "metadata": {},
    "name": "RoutineEditChecklistTaskItemGenerateUploadLinkMutation",
    "operationKind": "mutation",
    "text": "mutation RoutineEditChecklistTaskItemGenerateUploadLinkMutation {\n  uploadImageLink {\n    image {\n      id\n    }\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4ba1a29fcb1b3cbd6695ea75d0d268a";

export default node;
